/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Where the knowledge behind a question comes from. A procedure is named and may carry links; the other types are described in a sentence. OPL was called OpeRolka before.
 * @export
 * @enum {string}
 */

export const SourceTypeDto = {
    Procedure: 'PROCEDURE',
    Opl: 'OPL',
    Handbook: 'HANDBOOK',
    Other: 'OTHER'
} as const;

export type SourceTypeDto = typeof SourceTypeDto[keyof typeof SourceTypeDto];



